export enum TaskType {
  Transfer = 'Transfer',
  StockCount = 'StockCount',
  PurchaseOrder = 'PurchaseOrder',
  Order = 'order',
}